<template>
  <div class="charges">
    <v-simple-table>
      <tr>
        <th class="bd-t"></th>
        <th colspan="3" class="bd-x bd-b bd-t">Active</th>
        <th colspan="3" class="bd-b bd-t">Deferred</th>
      </tr>
      <tr class="bd-b">
        <th class="bd-b">Group Name</th>
        <th class="bd-l bd-b">Annual rate %</th>
        <th class="bd-b bd-l">Annual fixed charge</th>
        <th class="bd-r bd-b bd-l">Frequency</th>
        <th class="bd-b">Annual rate %</th>
        <th class="bd-b bd-l">Annual fixed charge</th>
        <th class="bd-b bd-l">Frequency</th>
      </tr>
      <tr v-for="charge in chargesList" :key="charge.ChargeId" @click="editCharge(charge)">
        <td class="bd-b">{{ charge.GroupName }}</td>
        <td class="bd-l bd-b">{{ charge.Rate }}</td>
        <td class="bd-b">{{ charge.FixedCharge }}</td>
        <td class="bd-r bd-b">{{ charge.Frequency }}</td>
        <td class="bd-b">{{ charge.DeferredRate }}</td>
        <td class="bd-b">{{ charge.DeferredFixed }}</td>
        <td class="bd-b">{{ charge.DeferredFrequency }}</td>
      </tr>
    </v-simple-table>

    <v-dialog v-model="showDialog" width="500" persistent>
      <v-card>
        <v-card-text class="pt-5 pb-0">
          <v-container>
            <v-row>
              <div>Active</div>
            </v-row>
            <v-row>
              <v-col cols="12" sm="6" md="4">
                <v-text-field
                  v-model="editedCharge.Rate"
                  label="Annual rate %"
                  type="number"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-text-field
                  v-model="editedCharge.FixedCharge"
                  label="Annual fixed charge"
                  type="number"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-select
                  v-model="editedCharge.Frequency"
                  :items="availableFrequency"
                  label="Frequency"
                ></v-select>
              </v-col>
            </v-row>
            <v-row>
              <div>Deferred</div>
            </v-row>
            <v-row>
              <v-col cols="12" sm="6" md="4">
                <v-text-field
                  label="Annual Rate %"
                  v-model="editedCharge.DeferredRate"
                  type="number"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-text-field
                  label="Annual fixed charge"
                  v-model="editedCharge.DeferredFixed"
                  type="number"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-select
                  label="Frequency"
                  v-model="editedCharge.DeferredFrequency"
                  :items="availableFrequency"
                ></v-select>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" outlined @click="cancelChange"> Cancel </v-btn>
          <v-btn color="primary" depressed @click="confirmChange"> Change </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-footer
      v-if="showFormButtons"
      padless
      fixed
      outlined
      class="pl-5 pr-5 pt-3 pb-3"
      color="white"
      elevation="3"
    >
      <v-spacer></v-spacer>
      <div class="btnsContainer">
        <v-btn color="primary" depressed @click="saveCharges">Save</v-btn>
      </div>
    </v-footer>
  </div>
</template>

<script>
export default {
  name: 'Charges',
  data() {
    return {
      loading: false,
      chargesList: [],
      showDialog: false,
      editedCharge: {},
      availableFrequency: ['Monthly', 'Quarterly', 'Yearly'],
      prevCharge: {},
    };
  },

  computed: {
    currentPlanId() {
      return this.$store.getters.currentPlanId;
    },
    showFormButtons() {
      const userPermission = this.$store.getters.getUserPermission(this.$route.path);
      if (userPermission && userPermission == 'Full') return true;

      return false;
    },
  },

  created() {
    this.getCharges();
    this.$root.currentPage = 'Investment';
  },

  destroyed() {
    this.$root.currentPage = null;
  },

  methods: {
    editCharge(charge) {
      if (!this.showFormButtons) return;
      this.showDialog = true;
      this.editedCharge = charge;
      this.prevCharge = { ...charge };
    },

    cancelChange() {
      this.showDialog = false;
      const index = this.chargesList.indexOf(this.editedCharge);
      this.chargesList.splice(index, 1, this.prevCharge);
      this.editedCharge = {};
      this.prevCharge = {};
    },

    confirmChange() {
      this.showDialog = false;
    },

    async getCharges() {
      this.loading = true;
      try {
        const response = await this.$api.get(`/Charges/GetCharges?planId=${this.currentPlanId}`);

        this.chargesList = response.data;
      } catch (error) {
        console.log(error.message);
      } finally {
        this.loading = false;
      }
    },

    async saveCharges() {
      this.loading = true;
      try {
        await this.$api.post(`/Charges/UpdateCharges`, {
          PlanId: this.currentPlanId,
          Charges: this.chargesList,
        });

        this.getCharges();
        this.$store.commit('setNotificationMessage', {
          type: 'success',
          text: 'Charges are updated successfully',
        });
      } catch (error) {
        console.log(error.message);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.charges {
  margin-top: 20px;
  margin-bottom: 20px;
  padding-left: 30px;
  padding-right: 30px;
}
th {
  font-size: 0.75rem;
  color: rgba(0, 0, 0, 0.6);
  height: 32px;
}
td {
  font-size: 0.875rem;
  color: rgba(0, 0, 0, 0.87);
  text-align: center;
  height: 32px;
}
tr:nth-child(odd):not(:first-child) {
  background-color: #f4f4f4;
}
tr:nth-child(n + 3):hover {
  cursor: pointer;
  background-color: #e1e1e1;
}
.bd-x {
  border-left: thin solid rgba(0, 0, 0, 0.12);
  border-right: thin solid rgba(0, 0, 0, 0.12);
}
.bd-l {
  border-left: thin solid rgba(0, 0, 0, 0.12);
}
.bd-r {
  border-right: thin solid rgba(0, 0, 0, 0.12);
}
.bd-b {
  border-bottom: thin solid rgba(0, 0, 0, 0.12);
}
.bd-t {
  border-top: thin solid rgba(0, 0, 0, 0.12);
}
</style>
